import { makeAutoObservable } from "mobx";
import { EditPwdEntity } from "../entity/edit-pwd-entity";

export class EditPwdStore {
    constructor() {
        makeAutoObservable(this);
    }

    public editPwd:EditPwdEntity|undefined;
    public useraccount:string = '';
    public password:string = '';
    public newpwd:string = '';

    public setEditPwd(value: EditPwdEntity) {
        this.editPwd = value;
    }

    public setUseraccount(value: string) {
        this.useraccount = value;
    }

    public setPassword(value: string) {
        this.password = value;
    }

    public setNewpwd(value: string) {
        this.newpwd = value;
    }
}